import * as React from "react";

import Alert from "@mui/material/Alert";

import Snackbar from "@mui/material/Snackbar";

const SnackbarComponent = ({
  handleClick,
  message,
  color,
  isCompleted = false,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={true}
      autoHideDuration={4000}
      onClose={handleClick}
    >
      <Alert
        onClose={handleClick}
        severity={color ? color : "success"}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
export default SnackbarComponent;
